import type { IApplicationTableColumn } from '../../api/applications/state.types'
import { DEFAULT_APPLICATION_TABLE_COLUMNS } from './table-default-schema'

const SCHEMA_VERSION = 1
const columnTypes = new Set(['text', 'number', 'boolean', 'date', 'datetime'])
const storageKey = (loginName: string) => 'crm:applications-table-schema:' + encodeURIComponent(loginName)

const validColumns = (value: unknown): value is IApplicationTableColumn[] => {
    if (!Array.isArray(value) || !value.length || value.length > 256) return false
    const names = new Set<string>()
    for (const column of value) {
        if (!column || typeof column !== 'object'
            || typeof column.name !== 'string' || !/^[a-z_][a-z0-9_]*$/i.test(column.name)
            || names.has(column.name) || !columnTypes.has(column.type)
            || (column.label !== undefined && (typeof column.label !== 'string' || column.label.length > 512))
            || (column.filterType !== undefined && column.filterType !== 'select')) return false
        names.add(column.name)
    }
    return names.has('application_id')
}

/** Cache metadata only; application rows and operator column settings stay separate. */
export const saveApplicationTableSchema = (loginName: string, columns: IApplicationTableColumn[]) => {
    if (!loginName || !validColumns(columns)) return
    try {
        const metadata = columns.map(({ name, type, label, filterType }) => ({ name, type, label, filterType }))
        localStorage.setItem(storageKey(loginName), JSON.stringify({ version: SCHEMA_VERSION, columns: metadata }))
    } catch {
        // Disabled or full localStorage must not prevent rendering the API schema.
    }
}

export const loadApplicationTableSchema = (loginName: string): IApplicationTableColumn[] => {
    if (loginName) {
        try {
            const cached = JSON.parse(localStorage.getItem(storageKey(loginName)) || 'null')
            if (cached?.version === SCHEMA_VERSION && validColumns(cached.columns)) return cached.columns
        } catch {
            // First load and unreadable metadata use the packaged column definitions.
        }
    }
    return DEFAULT_APPLICATION_TABLE_COLUMNS
}
